import { IApiError } from '@/models/apiError.model';
import { IPagination } from '@/models/pagination.model';
import { ISubscription } from '@/models/subscriptions.model';
import { TGetSubscriptionsQuery } from '@/modules/Subscriptions/helpers/types';

export const SUBSCRIPTIONS_SLICE_NAME = 'subscriptions';

export interface SubscriptionsState {
  pagination: IPagination | null;
  subscriptions: ISubscription[] | null;
  query: TGetSubscriptionsQuery | null;
  isLoading: boolean;
  error: IApiError | null;
}

export const initialState: SubscriptionsState = {
  pagination: null,
  subscriptions: null,
  query: null,
  isLoading: false,
  error: null,
};
